// extracted by mini-css-extract-plugin
export default {"datagrid":"DataGrid_datagrid__3eZZq"};